module.exports = __webpack_public_path__ + "static/media/room22SouthWall.8feb9fb2.jpg";